// extracted by mini-css-extract-plugin
export default {"backLink":"backLink__GLhuPSacdkem"};